import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import AcceptTerms from "pages/AcceptTerms";
import AccessDenied from "pages/AccessDenied";
import ForgotPassword from "pages/ForgotPassword";
import NotFound from "pages/NotFound";
import SignIn from "pages/SignIn";
import SignUp from "pages/SignUp";
import CreateRequest from "pages/protected/CreateRequest/CreateRequest";
import EmploymentDetails from "pages/protected/CreateRequest/EmploymentDetails";
import LoanDetails from "pages/protected/CreateRequest/LoanDetails";
import PersonalDetails from "pages/protected/CreateRequest/PersonalDetails";
import Home from "pages/protected/Home";

import { useTranslation } from "contexts/TranslationContext";
import AutoLoan from "pages/protected/CreateRequest/AutoLoan";
import Document from "pages/protected/CreateRequest/Document";
import FinancialDetails from "pages/protected/CreateRequest/FinancialDetails";
import Guarantors from "pages/protected/CreateRequest/Guarantors";
import Success from "pages/protected/CreateRequest/Success";
import Eligibility from "pages/protected/Settings/Eligibility";
import FAQ from "pages/protected/Settings/FAQ";
import Setting from "pages/protected/Settings/Setting";
import AddressDetails from "pages/protected/Settings/addressDetails";
import ChangePassword from "pages/protected/Settings/changePassword";
import ContactUs from "pages/protected/Settings/contactUs";
import DocumentList from "pages/protected/Settings/documentList";
import MaritalStatus from "pages/protected/Settings/maritalStatus";
import PersonalDetail from "pages/protected/Settings/personalDetail";
import TermsAndCondition from "pages/protected/Settings/termsAndCondition";
import UploadDocumentPage from "pages/protected/UploadDocumentPage";
import ViewContract from "pages/protected/ViewContract/ViewContract";
import ViewOffer from "pages/protected/ViewOffer/ViewOffer";
import ViewRequest from "pages/protected/ViewRequest/ViewRequest";
import { useLayoutEffect } from "react";
import { ProtectedResource } from "shared/components/ProtectedResource";
import routes from "shared/constants/routes";
import Layout from "shared/views/Layout/Layout";
import PreApp from "pages/protected/PreApplication"
import Partners from "pages/protected/Partners";
import Provider from "pages/protected/Partners/Provider";
import SuccessProvider from "pages/protected/Partners/Success";
import Vouchers from "pages/protected/Vouchers";
import SheriZeroMerchants from "pages/protected/SheriZeroMerchants";
import FinanceProducts from "pages/protected/FinanceProducts";
import SchoolProducts from "pages/protected/SchoolProducts";
import SchoolListing from "pages/protected/SchoolListing";

import ManageOffers from "pages/protected/Settings/ManageOffers";
import InstlmntDashboard from "pages/protected/Settings/InstlmntDashboard";
import SalaryInfo from "pages/protected/Settings/salaryInfo";
import SheriMerchants from "pages/protected/SheriMerchants";
import DentalProducts from "pages/protected/DentalProducts";
import DentalListing from "pages/protected/DentalListing";

// V2 dynamic-vendor pages — coexist with the legacy ones above.
// To disable V2, revert Home.jsx's FeaturedProducts import; these routes can stay (unreachable but harmless).
import SchoolListingV2 from "pages/protected/SchoolListingV2";
import SchoolProductsV2 from "pages/protected/SchoolProductsV2";
import DentalListingV2 from "pages/protected/DentalListingV2";
import DentalProductsV2 from "pages/protected/DentalProductsV2";

// Static "Other Services" catalog listing (Loan Restructure, Topup, Vehicle Services, …).
import OtherServicesListing from "pages/protected/OtherServices";
// Reusable "first screen" detail page for services with further steps.
import OtherServiceDetail from "pages/protected/OtherServices/ServiceDetail";

export default function AppRouter() {
  const { language } = useTranslation();

  useLayoutEffect(() => {
    window.document.dir = language?.dir;
  }, [language?.dir]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={routes.AUTH.SIGN_IN} />} />
        <Route
          path={routes.AUTH.FORGOT_PASSWORD}
          element={<ForgotPassword />}
        />
        <Route path={routes.AUTH.SIGN_IN} element={<SignIn />} />
        <Route path={routes.AUTH.SIGN_UP} element={<SignUp />} />
        <Route
          path={routes.AUTH.ACCEPT_TERMS_AND_COND}
          element={<AcceptTerms />}
        />
        {/* <Route
          path={routes.AUTH.COMPLAINTS}
          element={<Complaints />}
        /> */}

        <Route
          path={`/${routes.APP_ROOT}`}
          element={
            <ProtectedResource>
              <Layout />
            </ProtectedResource>
          }
        >
          <Route path="" element={<Navigate to={routes.HOME} />} />
          <Route path={routes.HOME} element={<Home />} />
          <Route path={routes.SETTING_ROOT} element={<Setting />} />
          <Route path={routes.SETTING.PERSONAL_DETAIL} element={<PersonalDetail />} />
          <Route path={routes.SETTING.ADDRESS_DETAIL} element={<AddressDetails />} />
          <Route path={routes.SETTING.MARITAL_STATUS} element={<MaritalStatus />} />
          <Route path={routes.SETTING.TERMS_AND_CONDITION} element={<TermsAndCondition />} />
          <Route path={routes.SETTING.ELIGIBILITY} element={<Eligibility />} />
          <Route path={routes.SETTING.CONTACT_US} element={<ContactUs />} />
          <Route path={routes.SETTING.DOCUMENT} element={<DocumentList />} />
          <Route path={routes.SETTING.FAQ} element={<FAQ />} />
          <Route path={routes.SETTING.CHANGE_PASSWORD} element={<ChangePassword />} />
          <Route path={routes.SETTING.MANAGE_OFFERS} element={<ManageOffers />} />
          <Route path={routes.SETTING.INSTLMNT_DASHBOADRD} element={<InstlmntDashboard />} />
          <Route path={routes.SETTING.SALARY_INFO} element={<SalaryInfo />} />

          <Route path={routes.CREATE_REQUEST} element={<CreateRequest />}>
            <Route
              path=""
              element={<Navigate to={routes.CREATE_REQUEST_PERSONAL_DETAILS} />}
            />
            <Route
              path={routes.CREATE_REQUEST_PERSONAL_DETAILS}
              element={<PersonalDetails />}
            />
            <Route
              path={routes.CREATE_REQUEST_EMPLOYMENT_DETAILS}
              element={<EmploymentDetails />}
            />
            <Route
              path={routes.CREATE_REQUEST_FINANCIAL_DETAILS}
              element={<FinancialDetails />}
            />
            <Route
              path={routes.CREATE_REQUEST_LOAN_DETAILS}
              element={<LoanDetails />}
            />
            <Route
              path={routes.CREATE_REQUEST_AUTO_LOAN}
              element={<AutoLoan />}
            />
            <Route
              path={routes.CREATE_REQUEST_DOCUMENT_DETAILS}
              element={<Document />}
            />            <Route
              path={routes.CREATE_REQUEST_GUARANTORS_DETAILS}
              element={<Guarantors />}
            />
            <Route path={routes.CREATE_REQUEST_SUCCESS + "/:appId/:version"} element={<Success />} />
          </Route>
          <Route
            path={routes.VIEW_REQUEST + "/:id"}
            element={<ViewRequest />}
          />
          <Route path={routes.VIEW_OFFER + "/:appId"} element={<ViewOffer />} />
          <Route
            path={routes.VIEW_CONTRACT + "/:appId/:contractStatus"}
            element={<ViewContract />}
          />
          <Route path={routes.UPLOAD_ADDITIONAL_DOCUMENT + "/:appId"} element={<UploadDocumentPage />} />
          <Route path={routes.PRE_APP} element={<PreApp />} />
          <Route path={routes.PARTNERS + "/:id"} element={<Partners />} />
          <Route path={routes.PARTNERS + "/:id/:partnerId/application"} element={<Provider />} />
          <Route path={routes.PARTNERS + "/:id/:partnerId/application" + "/:applId/success"} element={<SuccessProvider />} />
          <Route path={routes.VOUCHERS + "/:id"} element={<Vouchers />} />
          <Route path={routes.PRODUCTS + "/:id"} element={<FinanceProducts />} />
          <Route path={routes.SCHOOLS + "/:id"} element={<SchoolProducts />} />
          <Route path={routes.SCHOOLS + "/list"} element={<SchoolListing />} />
          <Route path={routes.DENTAL + "/list"} element={<DentalListing />} />
          <Route path={routes.DENTAL + "/:id"} element={<DentalProducts />} />
          {/* V2 dynamic-vendor routes — :id is the numeric vendor.ID (matches /v2/vendors/:id) */}
          <Route path={routes.SCHOOLS_V2 + "/list"} element={<SchoolListingV2 />} />
          <Route path={routes.SCHOOLS_V2 + "/:id"} element={<SchoolProductsV2 />} />
          <Route path={routes.DENTAL_V2 + "/list"} element={<DentalListingV2 />} />
          <Route path={routes.DENTAL_V2 + "/:id"} element={<DentalProductsV2 />} />
          {/* Other Services catalog — hardcoded now, backend-driven later */}
          <Route path={routes.OTHER_SERVICES + "/list"} element={<OtherServicesListing />} />
          <Route path={routes.OTHER_SERVICES + "/:id"} element={<OtherServiceDetail />} />
          <Route path={routes.MERCHANTS.SHERIZERO} element={<SheriZeroMerchants />} />
          <Route path={routes.MERCHANTS.SHERI} element={<SheriMerchants />} />
        </Route>

        <Route path={routes.ACCESS_DENIED} element={<AccessDenied />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
